var _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 42,
    viewBox: "0 0 59 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.3702,
    cy: 20.8204,
    rx: 29.8598,
    ry: 19.8204,
    transform: "rotate(15.4212 29.3702 20.8204)",
    fill: "#FF8A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenPercent);
export default __webpack_public_path__ + "static/media/ten-percent.c83abac4ed10f4e2d169b9dcccf5b457.svg";
export { ForwardRef as ReactComponent };